export default __webpack_public_path__ + "static/media/Rachel_BIO_Image.fc146bb8.jpg";